import { invitationReturnPath } from "./teamInvitations";

/** Allow only known local entry flows through sign-in, never arbitrary URLs. */
export function authReturnPath(value: unknown): string {
  const invitation = invitationReturnPath(value);
  if (invitation !== "/") return invitation;
  if (typeof value !== "string") return "/";
  const separator = value.indexOf("?");
  const path = separator < 0 ? value : value.slice(0, separator);
  const query = separator < 0 ? "" : value.slice(separator + 1);
  if (
    !path ||
    !/^\/apply\/r-[A-Za-z0-9_-]+\/?$/.test(path) ||
    /[\r\n#]/.test(value)
  )
    return "/";
  const params = new URLSearchParams(query);
  const allowed = new Set(["apply", "team", "section", "view"]);
  for (const [key] of params) {
    if (!allowed.has(key) || params.getAll(key).length !== 1) return "/";
  }
  if (params.has("apply") && params.get("apply") !== "1") return "/";
  const team = params.get("team");
  if (team && !/^team-[A-Za-z0-9_-]+$/.test(team)) return "/";
  const section = params.get("section");
  if (section && !/^[A-Za-z0-9_-]+$/.test(section)) return "/";
  if (params.has("view") && params.get("view") !== "review") return "/";
  return path.replace(/\/$/, "") + (separator < 0 ? "" : `?${query}`);
}
